import React, { useState } from 'react';
import useDidMountEffect from '@use-effect/did-update';

import { ToggleButton, Container, Option } from './Toggle.styled';

interface Option {
    label: string;
    value: string;
}

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    options: Option[];
    id: string;
    handleValueChange?: (value: string | null) => void;
}

const Toggle: React.FC<Props> = props => {
    const { options, id, defaultValue, handleValueChange } = props;
    const [value, setValue] = useState<string | undefined>(
        defaultValue ? (defaultValue as string) : undefined
    );
    const [isActive, setIsActive] = useState(
        options[1]?.value ? options[1].value === value : false
    );

    useDidMountEffect(() => {
        setValue(isActive ? options[1].value : options[0].value);
    }, [isActive]);

    useDidMountEffect(() => {
        if (value && handleValueChange) {
            handleValueChange(value);
        }
    }, [value]);

    const keyboardToggle = (event: React.KeyboardEvent) => {
        const handleToggle = () => {
            event.preventDefault();
            setIsActive(!isActive);
        };

        if (event.key === 'Enter') {
            handleToggle();
        } else if (event.key === ' ') {
            handleToggle();
        }
    };

    return (
        <>
            <Container $isActive={isActive}>
                <Option>{options[0].label}</Option>
                {options[1] && (
                    <>
                        <ToggleButton
                            $isActive={isActive}
                            onClick={() => setIsActive(!isActive)}
                            onKeyDown={event => keyboardToggle(event)}
                            tabIndex={0}
                            aria-pressed={true}
                            aria-label={`Selected year option ${
                                isActive ? options[1].label : options[0].label
                            }`}
                            id={id}
                        />
                        <Option>{options[1].label}</Option>
                    </>
                )}
            </Container>
        </>
    );
};

export default Toggle;
